import React, { FC, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { BackIcon } from "components/icons"
import { getIcon } from "utils/icon"

export const BackIconButton: FC<IconButtonProps> = ({ sx = {}, ...props }) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`BackIconButton`]?.styleOverrides || {}

  const { root, icon } = styleOverrides

  const backIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon, icon) || <BackIcon />,
    [theme, icon]
  )

  return (
    <IconButton
      size={props.size || "large"}
      edge="start"
      color="inherit"
      aria-label="back"
      sx={deepmerge(root, sx)}
      {...props}
    >
      {backIcon}
    </IconButton>
  )
}
